import { render, staticRenderFns } from "./TableBorder.vue?vue&type=template&id=0d0415fe&scoped=true&"
import script from "./TableBorder.vue?vue&type=script&lang=js&"
export * from "./TableBorder.vue?vue&type=script&lang=js&"
import style0 from "./TableBorder.vue?vue&type=style&index=0&id=0d0415fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0415fe",
  null
  
)

export default component.exports